export default "__VITE_ASSET__CkXD5TDQ__"